export type RawHtmlTableStyle =
{
    borderCollapse?: 'collapse' | 'separate';
    borderSpacing?: string;
    width?: string;
    tableLayout?: 'auto' | 'fixed';
    alignment?: 'left' | 'center' | 'right';
};

export type RawHtmlTableCellStyle =
{
    border?: string;
    padding?: string;
    width?: string;
    verticalAlign?: string;
    textAlign?: string;
};

export type RawHtmlTableStylePresetName =
    | 'plain'
    | 'grid';

export type RawHtmlTableStylePreset =
{
    table?: RawHtmlTableStyle;
    cell?: RawHtmlTableCellStyle;
};

export const RawHtmlTableStylePresets: Record<RawHtmlTableStylePresetName, RawHtmlTableStylePreset> =
{
    plain:
    {
    },

    grid:
    {
        table:
        {
            borderCollapse: 'collapse',
            borderSpacing: '0',
            width: '100%',
            tableLayout: 'auto',
        },
        cell:
        {
            border: '1px solid #bbb',
            padding: '6px 8px',
            verticalAlign: 'top',
        },
    },
};